import React from 'react';
import { useRecoilState } from 'recoil';

import { PlaylistMarkdownInput } from 'features/classCreation';
import { sbatGroupPlaylistContent } from 'atoms/sbatGroupPlaylistContent';

function PlaylistMarkdownContentInput() {
  const [content, setContent] = useRecoilState(sbatGroupPlaylistContent);

  return (
    <PlaylistMarkdownInput
      value={content}
      onChange={setContent}
    />
  );
}

export default PlaylistMarkdownContentInput;
